import { ICoreNavigation } from '@feast-it/ui/light';
import { PATHS } from './paths';
import { trackEvent } from '../modules/analytics';
import { GET_QUOTES_CLICKED } from './analytics';
import { getAbsoluteUrl } from '@/helpers/formatUrl';

export const coreNavigationFixture: ICoreNavigation = {
  desktopNavGroups: [
    {
      heading: 'Live',
      type: 'POPOVER',
      links: [
        {
          children: 'Music festivals',
          href: PATHS.live('music-festivals'),
        },
        {
          children: 'Togather Live',
          href: PATHS.live(),
        },
      ],
    },
    {
      heading: 'Corporate',
      type: 'POPOVER',
      links: [
        {
          children: 'Summer party venues',
          href: PATHS.venues('summer-party-venues-london'),
        },
        {
          children: 'Conference venues',
          href: PATHS.listings('venues/london/conference-venues'),
        },
        {
          children: 'Corporate catering',
          href: PATHS.listings('catering/corporate-event'),
        },
        { children: 'Event staff', href: PATHS.event('event-staff') },
        {
          children: 'Corporate party venues',
          href: PATHS.listings('venues/corporate-event'),
        },
        {
          children: 'London',
          href: PATHS.listings('venues/london/corporate-event'),
        },
      ],
    },
    {
      heading: 'Venues',
      type: 'POPOVER',
      links: [
        {
          children: 'Venue hire',
          href: PATHS.listings('venues'),
        },
        {
          children: 'Party venue hire',
          href: PATHS.listings('venues/party'),
        },
        {
          children: 'Summer party venues',
          href: PATHS.listings('venues/summer-party'),
        },
        {
          children: 'Christmas party venues',
          href: PATHS.listings('venues/christmas-party'),
        },
        {
          children: 'London venues',
          href: PATHS.listings('venues/london'),
        },
        {
          children: 'Halls for hire',
          href: PATHS.listings('venues/halls-for-hire'),
        },
      ],
    },
    {
      heading: 'All services',
      type: 'MEGA_MENU',
      sections: [
        {
          heading: { title: 'Street food' },
          iconName: 'Food',
          tagline: 'Browse all suppliers',
          links: [
            {
              children: 'Asian street food',
              href: PATHS.listings('catering/asian'),
            },
            {
              children: 'Caribbean street food',
              href: PATHS.listings('catering/caribbean'),
            },
            { children: 'London', href: PATHS.listings('catering/london') },
            {
              children: 'Street food for parties',
              href: PATHS.food('street-food-catering'),
            },
            {
              children: 'Indian street food',
              href: PATHS.listings('catering/indian'),
            },
            {
              children: 'Greek street food',
              href: PATHS.listings('catering/greek'),
            },
            {
              children: 'Manchester',
              href: PATHS.listings('catering/greater-manchester/manchester'),
            },
            {
              children: 'Pizza van hire',
              href: PATHS.listings('catering/pizza'),
            },
            {
              children: 'Fish & chip van hire',
              href: PATHS.listings('catering/fish-and-chip-vans'),
            },
            {
              children: 'Burger van hire',
              href: PATHS.listings('catering/burger-vans'),
            },
          ],
        },
        {
          heading: { title: 'Catering' },
          iconName: 'Staffing',
          tagline: 'Browse all suppliers',
          links: [
            {
              children: 'All catering',
              href: PATHS.listings('catering'),
            },
            {
              children: 'Food truck catering',
              href: PATHS.event('food-truck-catering'),
            },
            {
              children: 'Mobile catering',
              href: PATHS.event('mobile-catering'),
            },
            { children: 'BBQ catering', href: PATHS.listings('catering/bbq') },
            { children: 'Party catering', href: PATHS.event('party-catering') },
            {
              children: 'Dinner party catering',
              href: PATHS.listings('catering/dinner-party'),
            },
          ],
        },
        {
          heading: { title: 'Events' },
          iconName: 'Celebration',
          tagline: 'Browse all suppliers',
          links: [
            {
              children: 'Event photography',
              href: PATHS.listings('photographers'),
            },
            {
              children: 'London',
              href: PATHS.locations('parties-london'),
            },
            {
              children: 'Staff Hire',
              href: PATHS.weddings('other-services/staff-hire'),
            },
            {
              children: 'Christmas venues London',
              href: PATHS.listings('venues/london/christmas-party'),
            },
            {
              children: 'Christmas party',
              href: PATHS.listings('venues/christmas-party'),
            },
            {
              children: 'Wedding venues',
              href: PATHS.weddings('venues'),
            },
          ],
        },
      ],
    },
    {
      heading: 'Supplier spotlight',
      type: 'MEGA_MENU',
      sections: [
        {
          heading: { title: 'Venues' },
          iconName: 'Venues',
          tagline: 'Browse all suppliers',
          links: [
            {
              children: 'The Box',
              href: PATHS.supplierProfile('the-box'),
            },
            {
              children: 'Bubba Oasis',
              href: PATHS.supplierProfile('bubba-oasis-1'),
            },
            { children: 'Wagtail', href: PATHS.supplierProfile('wagtail') },
            {
              children: 'Corretto by the Canal',
              href: PATHS.supplierProfile('corretto-by-the-canal'),
            },
            {
              children: 'Woolwich Works',
              href: PATHS.supplierProfile('woolwich-works'),
            },
            {
              children: 'Colours Hoxton',
              href: PATHS.supplierProfile('colours-hoxton'),
            },
            { children: 'NTS Loft', href: PATHS.supplierProfile('nts-loft') },
          ],
        },
        {
          heading: { title: 'Street Food' },
          iconName: 'Food',
          tagline: 'Browse all suppliers',
          links: [
            {
              children: 'The Pizza Post',
              href: PATHS.supplierProfile('the-pizza-post'),
            },
            {
              children: 'Kang Foo Noodles',
              href: PATHS.supplierProfile('kang-foo-noodles'),
            },
            {
              children: "Marley's Tacos",
              href: PATHS.supplierProfile('marleys-tacos'),
            },
            {
              children: 'Pink Cactus',
              href: PATHS.supplierProfile('pink-cactus'),
            },
            {
              children: 'Burnout BBQ',
              href: PATHS.supplierProfile('burnout-bbq'),
            },
            { children: 'Doms Subs', href: PATHS.supplierProfile('doms-subs') },
            {
              children: "Smash N' Slide",
              href: PATHS.supplierProfile('smash-n-slide'),
            },
            {
              children: "Matilda's Waffle Boutique",
              href: PATHS.supplierProfile('matildas-waffle-boutique'),
            },
            {
              children: 'Mrs Falafel',
              href: PATHS.supplierProfile('mrs-falafel'),
            },
            { children: 'Turo Turo', href: PATHS.supplierProfile('turo-turo') },
            {
              children: 'Napoli on the Road',
              href: PATHS.supplierProfile('napoli-on-the-road-1'),
            },
            {
              children: "Jack's Gelato",
              href: PATHS.supplierProfile('jacks-gelato'),
            },
          ],
        },
      ],
    },

    {
      heading: 'Get listed',
      type: 'POPOVER',
      links: [
        {
          children: 'List as a supplier',
          href: PATHS.partners('become-a-partner'),
        },
        {
          children: 'List your venue',
          href: PATHS.partners('become-a-venue-partner'),
        },
        { children: 'Supplier perks', href: PATHS.partners('partner-perks') },
        {
          children: 'Togather community',
          href: PATHS.partners('togather-community'),
        },
      ],
    },
  ],
  mobileNavGroups: [
    {
      type: 'SUB_NAV_LINK_LIST',
      heading: 'Live',
      links: [
        {
          children: 'Music festivals',
          href: PATHS.live('music-festivals'),
        },
        {
          children: 'Togather Live',
          href: PATHS.live(),
        },
      ],
    },
    {
      type: 'SUB_NAV_LINK_LIST',
      heading: 'Corporate',
      links: [
        {
          children: 'Summer party venues',
          href: PATHS.venues('summer-party-venues-london'),
        },
        {
          children: 'Conference venues',
          href: PATHS.listings('venues/london/conference-venues'),
        },
        {
          children: 'Corporate catering',
          href: PATHS.listings('catering/corporate-event'),
        },
        { children: 'Event staff', href: PATHS.event('event-staff') },
        {
          children: 'Corporate party venues',
          href: PATHS.listings('venues/corporate-event'),
        },
        {
          children: 'London',
          href: PATHS.listings('venues/london/corporate-event'),
        },
      ],
    },
    {
      type: 'SUB_NAV_LINK_LIST',
      heading: 'Venues',
      links: [
        {
          children: 'Venue hire',
          href: PATHS.listings('venues'),
        },
        {
          children: 'Party venue hire',
          href: PATHS.listings('venues/party'),
        },
        {
          children: 'Summer party venues',
          href: PATHS.listings('venues/summer-party'),
        },
        {
          children: 'Christmas party venues',
          href: PATHS.listings('venues/christmas-party'),
        },
        {
          children: 'London venues',
          href: PATHS.listings('venues/london'),
        },
        {
          children: 'Halls for hire',
          href: PATHS.listings('venues/halls-for-hire'),
        },
      ],
    },
    {
      type: 'SUB_NAV_LINK_CATEGORIES',
      isNestedGroup: false,
      heading: 'All services',
      categoryLink: { children: 'Browse all services', href: PATHS.browse },
      sections: [
        {
          heading: 'Food',
          links: [
            {
              children: 'Asian street food',
              href: PATHS.listings('catering/asian'),
            },
            {
              children: 'Caribbean street food',
              href: PATHS.listings('catering/caribbean'),
            },
            { children: 'London', href: PATHS.listings('catering/london') },
            {
              children: 'Street food for parties',
              href: PATHS.food('street-food-catering'),
            },
            {
              children: 'Indian street food',
              href: PATHS.listings('catering/indian'),
            },
            {
              children: 'Greek street food',
              href: PATHS.listings('catering/greek'),
            },
            {
              children: 'Manchester',
              href: PATHS.listings('catering/greater-manchester/manchester'),
            },
            {
              children: 'Pizza van hire',
              href: PATHS.listings('catering/pizza'),
            },
            {
              children: 'Fish & chip van hire',
              href: PATHS.listings('catering/fish-and-chip-vans'),
            },
            {
              children: 'Burger van hire',
              href: PATHS.listings('catering/burger-vans'),
            },
          ],
        },
        {
          heading: 'Celebration',
          links: [
            {
              children: 'Event photography',
              href: PATHS.listings('photographers'),
            },
            {
              children: 'London',
              href: PATHS.locations('parties-london'),
            },
            {
              children: 'Staff Hire',
              href: PATHS.weddings('other-services/staff-hire'),
            },
            {
              children: 'Christmas venues London',
              href: PATHS.listings('venues/london/christmas-party'),
            },
            {
              children: 'Christmas party',
              href: PATHS.listings('venues/christmas-party'),
            },
            {
              children: 'Wedding venues',
              href: PATHS.weddings('venues'),
            },
          ],
        },
      ],
    },
    {
      type: 'SUB_NAV_LINK_CATEGORIES',
      isNestedGroup: false,
      heading: 'Supplier spotlight',
      sections: [
        {
          heading: 'Venues',
          links: [
            {
              children: 'The Box',
              href: PATHS.supplierProfile('the-box'),
            },
            {
              children: 'Bubba Oasis',
              href: PATHS.supplierProfile('bubba-oasis-1'),
            },
            { children: 'Wagtail', href: PATHS.supplierProfile('wagtail') },
            {
              children: 'Corretto by the Canal',
              href: PATHS.supplierProfile('corretto-by-the-canal'),
            },
            {
              children: 'Woolwich Works',
              href: PATHS.supplierProfile('woolwich-works'),
            },
            {
              children: 'Colours Hoxton',
              href: PATHS.supplierProfile('colours-hoxton'),
            },
            { children: 'NTS Loft', href: PATHS.supplierProfile('nts-loft') },
          ],
        },
        {
          heading: 'Food',
          links: [
            {
              children: 'The Pizza Post',
              href: PATHS.supplierProfile('the-pizza-post'),
            },
            {
              children: 'Kang Foo Noodles',
              href: PATHS.supplierProfile('kang-foo-noodles'),
            },
            {
              children: "Marley's Tacos",
              href: PATHS.supplierProfile('marleys-tacos'),
            },
            {
              children: 'Pink Cactus',
              href: PATHS.supplierProfile('pink-cactus'),
            },
            {
              children: 'Burnout BBQ',
              href: PATHS.supplierProfile('burnout-bbq'),
            },
            { children: 'Doms Subs', href: PATHS.supplierProfile('doms-subs') },
            {
              children: "Smash N' Slide",
              href: PATHS.supplierProfile('smash-n-slide'),
            },
            {
              children: "Matilda's Waffle Boutique",
              href: PATHS.supplierProfile('matildas-waffle-boutique'),
            },
            {
              children: 'Mrs Falafel',
              href: PATHS.supplierProfile('mrs-falafel'),
            },
            { children: 'Turo Turo', href: PATHS.supplierProfile('turo-turo') },
            {
              children: 'Napoli on the Road',
              href: PATHS.supplierProfile('napoli-on-the-road-1'),
            },
            {
              children: "Jack's Gelato",
              href: PATHS.supplierProfile('jacks-gelato'),
            },
          ],
        },
      ],
    },

    {
      type: 'SUB_NAV_LINK_LIST',
      heading: 'Get listed',
      links: [
        {
          children: 'List as a supplier',
          href: PATHS.partners('become-a-partner'),
        },
        {
          children: 'List your venue',
          href: PATHS.partners('become-a-venue-partner'),
        },
        { children: 'Supplier perks', href: PATHS.partners('partner-perks') },
        {
          children: 'Togather community',
          href: PATHS.partners('togather-community'),
        },
      ],
    },
    {
      type: 'LINK',
      link: { children: 'Login', href: '/login' },
    },
  ],
  buttonLinks: {
    login: {
      href: PATHS.login,
    },
    enquiry: {
      href: PATHS.enquiryForm,
      onClick: () =>
        trackEvent(GET_QUOTES_CLICKED, {
          source: 'header',
          currentPage: getAbsoluteUrl(window.location.pathname),
          destinationUrl: getAbsoluteUrl(PATHS.enquiryForm),
        }),
    },
  },
  homepageLinkOverride: PATHS.home,
};
